import { render } from "./B2bPageSalesReport.vue?vue&type=template&id=e9a09b42&scoped=true&lang=pug"
import script from "./B2bPageSalesReport.vue?vue&type=script&lang=js"
export * from "./B2bPageSalesReport.vue?vue&type=script&lang=js"

import "./B2bPageSalesReport.vue?vue&type=style&index=0&id=e9a09b42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a09b42"]])

export default __exports__